import React from 'react';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';
import { getDateValue } from '../../utils/date';
import { fetchStatusCommentDetails } from '../../actions/project_actions';

class CommentsViewForm extends React.Component {
    // static PropTypes = {
    //     comment: PropTypes.object.isRequired,
    //     statusCommentDetails: PropTypes.array.isRequired,
    //     fetchStatusCommentDetails: PropTypes.func.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            statusCommentDetails: []
        }
    }

    UNSAFE_componentWillMount() {
        this.loadInitial();
      }
    
      loadInitial() {
       this.props.fetchStatusCommentDetails(this.props.projectId, this.props.comment.id);
      }

      UNSAFE_componentWillReceiveProps(nextProps) {
        const statusCommentDetails = nextProps.statusCommentDetails;
    
        this.setState({
          statusCommentDetails: statusCommentDetails,
        });
      }

      renderTable (statusCommentDetails) {
        
            return (
              <div className="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>Comment</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                    </tr>
                  </thead>
                   <tbody>
                  { statusCommentDetails.map(comment =>
                    <tr key={comment.id}>
                    <td>{comment.comment}</td>
                      <td>{comment.createdUserUniqueName}</td>
                      <td>{getDateValue(comment.createdDate)}</td>
                    </tr>
                  )}
                  </tbody> 
                </table>
              </div>
            );
          }

    render() {
        const  statusCommentDetails  = this.state.statusCommentDetails;

        return (
            <div className="modal-form">

        <div className="project-detail-comments">
          <div className="col s12">
            {statusCommentDetails.length
              ? this.renderTable(statusCommentDetails)
              : <div>This project has no comments yet.</div>}
          </div>
        </div>

            </div>
        )
    }
}

CommentsViewForm.propTypes = {
  comment: PropTypes.object.isRequired,
  statusCommentDetails: PropTypes.array.isRequired,
  fetchStatusCommentDetails: PropTypes.func.isRequired
};

function mapStateToProps (state) {
    return {
      projectId: state.projectsStore.info.projectId,
      statusCommentDetails: state.projectsStore.statusCommentDetails
    };
  }

export default connect(mapStateToProps, {fetchStatusCommentDetails})(CommentsViewForm);